<mat-toolbar color="primary" class="toolbar">
    <a mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
    </a>
    <mat-menu #menu="matMenu">
        <a mat-menu-item (click)="gotoQuote()">
            <mat-icon>feed</mat-icon>
            <div>Quote</div>
        </a>
        <a mat-menu-item (click)="gotoQuestionnaire()">
            <mat-icon>feed</mat-icon>
            <div>Questionnaire</div>
        </a>
        <a mat-menu-item (click)="gotoPay()" *ngIf="paymentVisible">
            <mat-icon>credit_card</mat-icon>
            <span>Payment</span>
        </a>
        <a mat-menu-item (click)="gotoSign()" *ngIf="signVisible">
            <mat-icon>create</mat-icon>
            <div>Sign</div>
        </a>
    </mat-menu>
    <img  src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo chat-image" />
    <div class="toolbar-inner-payment">High Limits Disability Insurance Application</div>
</mat-toolbar>
<div class="app-progress">
    <div class=app-progress-inner>Application Progress</div>
    <ngb-progressbar class="mb-3 progress-bar" [showValue]="true" type="primary" [value]="percent" />
</div>
<div class="page-background-payment">
    <br />
    <div *ngIf="makePayment===false" class="bill">
        <div class="breakdown">
            <div>
                <div class="taxes-fees-payment">
                    <div class="taxes-fees-inner">
                        <div class="estimate-text-payment">Annual Price</div>
                    </div>
                    <div class="taxes-fees-inner">
                        <div class="left">Premium:</div>
                        <div class="right">{{premium | currency}}</div>
                    </div>
                    <div class="taxes-fees-inner" *ngIf="SLTaxes > 0">
                        <div class="left">{{SLTaxesText}}*:</div>
                        <div class="right">{{SLTaxes | currency}}</div>
                    </div>
                    <!-- <div class="taxes-fees-inner" *ngIf="SLFees > 0">
                        <div class="left">Fees*:</div>
                        <div class="right">{{SLFees | currency}}</div>
                    </div> -->
                    <div class="taxes-fees-inner" *ngIf="otherFees > 0">
                        <div class="left">Other Fees*:</div>
                        <div class="right">{{otherFees | currency}}</div>
                    </div>
                </div>
            </div>
            <div class="total-area-area">
                <div class="total-text">Total:</div>
                <div class="total-cost">{{total | currency}}</div>
            </div>
        </div>
        <div class="fine-details">
            <div class="small-text">*State taxes and fees are subject to change each year.</div>
        </div>
        <div class="payment-frequency font-weight">
            <mat-radio-group aria-label="Payment Frequency" (change)="getQuarterly()" [(ngModel)]="paymentFrequency">
                <mat-radio-button [value]="12"><span class="semibold">Annual Billing</span></mat-radio-button>
                <mat-radio-button [value]="13"><span class="semibold">Quarterly Billing</span> <br/>
                    <span style="font-weight: normal"><span class="nobold">The first bill will include 25% of premium and all taxes and fees for the year.  Remaining premium is evenly split across the last 3 quarters.</span></span></mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="payment-schedule" *ngIf="paymentFrequency == 13">
            <div class="payment-schedule-text semibold">Quarterly Payment Schedule</div>
            @for (schedule of schedules; track schedule; let i = $index){
            <div class="payment-schedule-area">
                <div class="payment-schedule-text">Quarter {{i+1}}</div>
                <div class="payment-schedule-text">{{schedule.Amount | currency}}</div>
            </div>
            }
        </div>
        <div class="continue">
            <button (click)="gotoQuestionnaire()" class="chat-button" mat-flat-button>Back</button>
            <button class="button-mgis" (click)="continue()" class="chat-button chat-button-define" mat-flat-button>Continue</button>
        </div>
    </div>
    <div *ngIf="makePayment===true" class="payment">
        <div class="payment-inner">
            <div class="payment-text">Recurring Payment Method</div>
            <div class="">Note: MGIS will not charge your bank or credit card until your application for insurance has
                been reviewed and approved.</div>
            <div class="payment-type">
                <mat-radio-group aria-label="Payment Frequency" [(ngModel)]="paymentType">
                    <mat-radio-button value="R">Bank Payment / ACH</mat-radio-button>
                    <mat-radio-button value="cc">Credit Card (3% Fee Applies)</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="ach-form" *ngIf="paymentType === 'R'">
            <mat-form-field class="select">
                <mat-label class="label-text">Bank Routing Number</mat-label>
                <input matInput [(ngModel)]="routingNumber" maxlength="9" inputmode="numeric"
                    [errorStateMatcher]="matcher1" required minlength="9">
                <mat-error>Enter a valid Routing Number</mat-error>
            </mat-form-field>
            <mat-form-field class="select">
                <mat-label class="label-text">Account Number</mat-label>
                <input matInput [(ngModel)]="accountNumber" maxlength="12" inputmode="numeric"
                    [errorStateMatcher]="matcher2" required minlength="8">
                <mat-error>Enter your Account Number</mat-error>
            </mat-form-field>
            <mat-form-field class="select">
                <mat-label class="label-text">Account Type</mat-label>
                <mat-select matInput [(ngModel)]="accountType" [errorStateMatcher]="matcher3" required>
                    <mat-option value="checking">Checking</mat-option>
                    <mat-option value="savings">Savings</mat-option>
                </mat-select>
                <mat-error>Please select the Account Type</mat-error>
            </mat-form-field>
        </div>
        <div class="cc-form" *ngIf="paymentType === 'cc'">
            <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                <div id="payment-element"></div>
                <ngx-stripe-payment [options]="paymentOptions"></ngx-stripe-payment>
            </ngx-stripe-elements>
        </div>
        <div class="payment-buttons">
            <button class="button-mgis" (click)="back()" class="chat-button chat-button-define" mat-flat-button>Back</button>
            <button class="button-mgis" *ngIf="paymentType ==='cc'" (click)="reviewCC()" class="chat-button chat-button-define" mat-flat-button>Review</button>
            <button class="button-mgis" *ngIf="paymentType ==='R'" (click)="reviewEFT()" class="chat-button chat-button-define" mat-flat-button>Review</button>
        </div>
    </div>
</div>